import { render, staticRenderFns } from "./WarehouseSalesOrders.vue?vue&type=template&id=083ac6f0&"
import script from "./WarehouseSalesOrders.vue?vue&type=script&lang=js&"
export * from "./WarehouseSalesOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports